@if (!imageFailed) {
  <p-avatar
    [image]="avatarUrl"
    [pTooltip]="user?.displayName"
    tooltipPosition="bottom"
    shape="circle"
    [style]="{ width: sizeStyle, height: sizeStyle }"
    (onImageError)="onImageError()"
  ></p-avatar>
}
@if (imageFailed) {
  <p-avatar
    [label]="initials"
    [pTooltip]="user?.displayName"
    tooltipPosition="bottom"
    shape="circle"
    [style]="{ width: sizeStyle, height: sizeStyle, fontSize: '12px' }"
  ></p-avatar>
}
